import type { ScheduledCopyOverrides } from './scheduled-page-copy-types';

export const scheduledPageCopyOverridesIndicSea = {
  hi: {
    header: {
      navLabel: 'शेड्यूल्ड',
      title: 'शेड्यूल्ड',
      subtitle: 'एजेंट कार्य जो आपके समय पर अपने आप चलते हैं।',
      searchPlaceholder: 'शेड्यूल खोजें',
      newSchedule: 'नया शेड्यूल',
      create: 'बनाएँ',
      createWithAgent: 'एजेंट के साथ बनाएँ',
      setUpManually: 'मैन्युअल रूप से सेट करें',
      createWithAgentPrompt:
        'शेड्यूल किया गया कार्य सेट अप करने में मेरी मदद करें। समझाएँ कि यह कैसे काम करता है, फिर पूछें कि मुझे क्या और कब चाहिए। पुष्टि के लिए पूर्वावलोकन दिखाएँ।',
      timezone: 'समय {timezone} में दिखाए गए हैं',
    },
    filters: {
      all: 'सभी',
      mine: 'मेरे',
      shared: 'साझा',
      archived: 'संग्रहीत',
      filters: 'फ़िल्टर',
      moreScopes: 'शेड्यूल के अन्य दृश्य',
      status: 'स्थिति',
      anyStatus: 'कोई भी स्थिति',
      active: 'सक्रिय',
      paused: 'रुका हुआ',
      completed: 'पूरा',
    },
    calendar: {
      label: 'शेड्यूल किए गए एजेंट कार्यों का कैलेंडर',
      emptyTitle: 'अपना अगला शेड्यूल्ड कार्य प्लान करें',
      more: '{count} और',
      truncated:
        'इस अवधि में और परिणाम हैं। सभी देखने के लिए तारीखें या फ़िल्टर सीमित करें।',
      offlineTitle: 'आप ऑफ़लाइन हैं',
      offlineDescription:
        'शेड्यूल लोड करने और बदलाव करने के लिए फिर से कनेक्ट करें।',
      malformed: 'इस शेड्यूल को सुरक्षित रूप से नहीं दिखाया जा सका।',
      loading: 'कैलेंडर लोड हो रहा है',
      allDay: 'शेड्यूल समयरेखा',
    },
    common: {
      close: 'बंद करें',
      cancel: 'रद्द करें',
      save: 'बदलाव सहेजें',
      create: 'शेड्यूल बनाएँ',
      edit: 'संपादित करें',
      retry: 'फिर कोशिश करें',
      back: 'वापस',
      next: 'जारी रखें',
      loading: 'लोड हो रहा है',
      view: 'देखें',
      unknown: 'अज्ञात',
      notAvailable: 'उपलब्ध नहीं',
    },
  },
  id: {
    header: {
      navLabel: 'Terjadwal',
      title: 'Terjadwal',
      subtitle: 'Tugas agen yang berjalan tanpa pengawasan sesuai waktu Anda.',
      searchPlaceholder: 'Cari jadwal',
      newSchedule: 'Jadwal baru',
      create: 'Buat',
      createWithAgent: 'Buat dengan agen',
      setUpManually: 'Atur secara manual',
      createWithAgentPrompt:
        'Bantu saya menyiapkan tugas terjadwal. Jelaskan cara kerjanya, lalu tanyakan apa yang saya perlukan dan kapan. Tampilkan pratinjau untuk konfirmasi.',
      timezone: 'Waktu ditampilkan dalam {timezone}',
    },
    filters: {
      all: 'Semua',
      mine: 'Milik saya',
      shared: 'Dibagikan',
      archived: 'Diarsipkan',
      filters: 'Filter',
      moreScopes: 'Tampilan jadwal lainnya',
      status: 'Status jadwal',
      anyStatus: 'Status apa pun',
      active: 'Aktif',
      paused: 'Dijeda',
      completed: 'Selesai',
    },
    calendar: {
      label: 'Kalender tugas agen terjadwal',
      emptyTitle: 'Rencanakan tugas terjadwal berikutnya',
      more: '{count} lainnya',
      truncated:
        'Rentang ini memiliki lebih banyak hasil. Persempit tanggal atau filter untuk melihat semuanya.',
      offlineTitle: 'Anda sedang offline',
      offlineDescription:
        'Hubungkan kembali untuk memuat jadwal dan membuat perubahan.',
      malformed: 'Jadwal ini tidak dapat ditampilkan dengan aman.',
      loading: 'Memuat kalender',
      allDay: 'Linimasa jadwal',
    },
    common: {
      close: 'Tutup',
      cancel: 'Batal',
      save: 'Simpan perubahan',
      create: 'Buat jadwal',
      edit: 'Ubah',
      retry: 'Coba lagi',
      back: 'Kembali',
      next: 'Lanjutkan',
      loading: 'Memuat',
      view: 'Lihat',
      unknown: 'Tidak diketahui',
      notAvailable: 'Tidak tersedia',
    },
  },
  vi: {
    header: {
      navLabel: 'Đã lên lịch',
      title: 'Đã lên lịch',
      subtitle: 'Tác vụ đại lý tự chạy theo thời gian của bạn.',
      searchPlaceholder: 'Tìm lịch',
      newSchedule: 'Lịch mới',
      create: 'Tạo',
      createWithAgent: 'Tạo bằng tác nhân',
      setUpManually: 'Thiết lập thủ công',
      createWithAgentPrompt:
        'Hãy giúp tôi thiết lập một tác vụ theo lịch. Giải thích cách hoạt động, rồi hỏi tôi cần gì và khi nào. Hiển thị bản xem trước để tôi xác nhận.',
      timezone: 'Thời gian hiển thị theo {timezone}',
    },
    filters: {
      all: 'Tất cả',
      mine: 'Của tôi',
      shared: 'Đã chia sẻ',
      archived: 'Đã lưu trữ',
      filters: 'Bộ lọc',
      moreScopes: 'Các chế độ xem lịch khác',
      status: 'Trạng thái',
      anyStatus: 'Mọi trạng thái',
      active: 'Đang hoạt động',
      paused: 'Tạm dừng',
      completed: 'Hoàn tất',
    },
    calendar: {
      label: 'Lịch tác vụ đại lý đã lên lịch',
      emptyTitle: 'Lên kế hoạch cho tác vụ theo lịch tiếp theo',
      more: 'Thêm {count}',
      truncated:
        'Khoảng thời gian này còn kết quả khác. Hãy thu hẹp ngày hoặc bộ lọc để xem tất cả.',
      offlineTitle: 'Bạn đang ngoại tuyến',
      offlineDescription: 'Kết nối lại để tải lịch và thực hiện thay đổi.',
      malformed: 'Không thể hiển thị lịch này một cách an toàn.',
      loading: 'Đang tải lịch',
      allDay: 'Dòng thời gian lịch',
    },
    common: {
      close: 'Đóng',
      cancel: 'Hủy',
      save: 'Lưu thay đổi',
      create: 'Tạo lịch',
      edit: 'Sửa',
      retry: 'Thử lại',
      back: 'Quay lại',
      next: 'Tiếp tục',
      loading: 'Đang tải',
      view: 'Xem',
      unknown: 'Không rõ',
      notAvailable: 'Không khả dụng',
    },
  },
} satisfies ScheduledCopyOverrides;
